import * as _ from "lodash";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { CSVLink } from "react-csv";
import { useSnackbar } from "notistack";

import "./Salaries.scss";
import Loader from "../loder";
import DateCarousel from "../date-carousel";
import YeulsTable from "../yeuls-table";
import EmployeeSalary from "./employee-salary";
import SendToMaskoreshetButton from "./send-to-maskoreshet-button";
import { getUsers } from "../../api/requests/users";
import { SalaryDate, SalaryStatus } from "../../shared/constants";
import Search from "../search";
import { ReactComponent as ArrowBackIcon } from "../../shared/icons/arrow-back-icon.svg";
import { addSalary, getAllSalaries, getAllSalaryRecords, importSalary, updateSalary } from "../../api/requests/salary";
import { sendSalaryToMaskoreshet } from "../../api/requests/maskoreshet";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Calculator, CheckCircle, Clock, Download, FileText, Search as SearchIcon } from "lucide-react";
import EditableLineInput from "../editable-line-input";
import { getAllInvoices } from "../../api/requests/invoice";
import { getAllReceipts } from "../../api/requests/receipt";
import { getAllExpenses } from "../../api/requests/expense";
import { NumbersService } from "../../services/numbers";
import ConfirmDialog from "../confirm-dialog";
import { getClients } from "../../api/requests/client";
import { getSuppliers } from "../../api/requests/supplier";
import { setLanguage } from "../../redux/actions/language";
import { SessionStorageService } from "../../shared/services/session-storage";
import { AuthService } from "../../services/auth";


const tabIds = {
  first: 0,
  ninth: 1,
}

const Salaries = (props) => {
  const { fullScreen } = props;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const accessKey = fullScreen ? (new URLSearchParams(location.search).get("key") || "").trim() : null;
  const missingAccessKey = fullScreen && !accessKey;

  if (accessKey) {
    AuthService.setToken(accessKey);
  }
  const [showLoader, setShowLoader] = useState(false)
  const tableHeaders = [t("salary-col-employee"), t("total-cost"), t("salary-col-status"), t("monthly-link-table-header"), t("notes"), t("send-to-maskoreshet"), t("salary-link-table-header")];
  const tableColumns = "nameView.costView.statusView.monthlyOverviewLinkView.notesView.sendToMaskoreshetView.salaryLinkView";
  const [currentTabId, setCurrentTabId] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [exportData, setExportData] = useState([]);
  const [updateTable, setUpdateTable] = useState(true);
  const [importData, setImportData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const csvLink = useRef();
  const [clients, setClients] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const csvHeaders = [
    { label: 'מספר עובד', key: "oketz_number" },
    // { label: t('identity-number'), key: "identity_number" },
    // { label: 'נטו לתשלום', key: "total_oketz_net" },
    // { label: 'נטו', key: "total_oketz_net_to_pay" },
    { label: 'שכר יסוד-ערך', key: "total_oketz_cost" },
  ];
  const [employees, setEmployees] = useState([]);
  const [groupedEmployees, setGroupedEmployees] = useState({
    firstDateSalaryEmployees: [],
    ninthDateSalaryEmployees: [],
  });

  const [filteredEmployees, setFilteredEmployees] = useState({
    firstDateSalaryEmployees: [],
    ninthDateSalaryEmployees: [],
  });
  const [filterValue, setFilterValue] = useState("");
  const [currentMonth, setCurrentMonth] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  const [importMonth, setImportMonth] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  useEffect(() => {
    if (missingAccessKey) {
      return;
    }
    refreshEmployees();
  }, []);

  const refreshEmployees = () => {
    setShowLoader(true);
    Promise.all([getUsers(), getAllInvoices(), getAllReceipts(), getAllExpenses(), getAllSalaries(), getAllSalaryRecords(), getClients(), getSuppliers()])
      .then(([users, invoices, receipts, expenses, salaries, salaryRecords, clients, suppliers]) => {
        setEmployees(_(users)
          .filter((user) => user.userTerms)
          .map((user) => ( {
            ...user,
            invoices: _.filter(invoices, { user_id: user.id }),
            receipts: _.filter(receipts, { user_id: user.id }),
            expenses: _.filter(expenses, { user_id: user.id }),
            salaries: _.filter(salaries, { user_id: user.id }),
            salaryRecords: _.filter(salaryRecords, { user_id: user.id }),
          } ))
          .value()
        );
        setSuppliers(suppliers);
        setClients(clients);
      })
      .finally(() => setShowLoader(false));
  }

  useEffect(() => {
    const calculatedEmployees = _.map(employees, (employee) => {
      const currentMonthInvoices = _.filter(employee.invoices, (invoice) => {
        const invoiceCreateDate = new Date(invoice.created_on);

        return invoiceCreateDate.getMonth() + 1 === currentMonth.month && invoiceCreateDate.getFullYear() === currentMonth.year;
      });
      const totalIncome = Math.floor(_(currentMonthInvoices).map(i => +i.amount_with_vat).sum() * 100) / 100;
      const currentSalary = _.find(employee.salaries, (salary) =>
        salary.year === currentMonth.year &&
        salary.month === currentMonth.month);
      const isDone = currentSalary?.status === SalaryStatus.done;
      const employeeInitial = (employee.firstname || "").trim().charAt(0);

      return {
        ...employee,
        totalIncome,
        salaryStatus: currentSalary?.status,
        monthlyFileDone: !!currentSalary?.monthly_overview_file_link,
        salaryFileDone: !!currentSalary?.salary_file_link,
        agentTotalIncomes : currentSalary?.agent_total_incomes || 0,
        nameView: <div className="salary-employee-cell">
          <div className="salary-avatar">{employeeInitial}</div>
          <div className="salary-employee-text">
            <div className="salary-employee-name">{employee.firstname}</div>
            {employee.identity_number && <div className="salary-employee-id">{t("identity-number")} {employee.identity_number}</div>}
          </div>
        </div>,
        costView: isDone ?
          <span className="salary-cost">₪{` ${NumbersService.numberWithCommas(currentSalary.agent_total_paid, true)}`}</span> :
          <span className="salary-cost-empty">—</span>,
        totalNetView: <EditableLineInput
          value={currentSalary?.total_oketz_net}
          type="number"
          onSave={(oketzNet) => updateEmployeeSalary(employee, { total_oketz_net: +oketzNet })}>{currentSalary?.total_oketz_net ? `₪ ${NumbersService.numberWithCommas(currentSalary?.total_oketz_net, true)}` : ""}</EditableLineInput>,
        totalNetToPayView: <EditableLineInput
          value={currentSalary?.total_oketz_net_to_pay}
          type="number"
          onSave={(oketzNetToPay) => updateEmployeeSalary(employee, { total_oketz_net_to_pay: +oketzNetToPay })}>{currentSalary?.total_oketz_net_to_pay ? `₪ ${NumbersService.numberWithCommas(currentSalary?.total_oketz_net_to_pay, true)}` : ""}</EditableLineInput>,
        totalCostView: <EditableLineInput
          value={currentSalary?.total_oketz_cost}
          type="number"
          onSave={(oketzCost) => updateEmployeeSalary(employee, { total_oketz_cost: +oketzCost })}>{currentSalary?.total_oketz_cost ? `₪ ${NumbersService.numberWithCommas(currentSalary?.total_oketz_cost, true)}` : ""}</EditableLineInput>,

        statusView: <div className={"salary-status-pill" + ( isDone ? " done" : "" )}>
          {isDone ? <CheckCircle size={12} /> : <Clock size={12} />}
          <span>{isDone ? t("done") : t("open")}</span>
        </div>,
        sendToMaskoreshetView: !currentSalary ? (
          <span className="salary-summary-only">
            <FileText size={12} />
            {t("summary-only")}
          </span>
        ) : (
          <SendToMaskoreshetButton
            salary={currentSalary}
            disabled={!isDone}
            onSend={() => handleSendToMaskoreshet(employee, currentSalary)}
          />
        ),
        notesView: <EditableLineInput
          value={currentSalary?.notes}
          onSave={(notes) => updateEmployeeSalary(employee, { notes })}>
          <span className={"salary-note-display" + ( currentSalary?.notes ? "" : " is-empty" )}>{currentSalary?.notes}</span>
        </EditableLineInput>,
        monthlyOverviewLinkView: <button
          type="button"
          className="salary-monthly-summary-btn"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}>
          <Calculator size={12} />
          {t("monthly-link-table-header")}
        </button>,
        salaryLinkView: <button
          type="button"
          className="salary-download-btn"
          disabled={!currentSalary?.salary_file_link}
          onClick={() => {
            if (currentSalary?.salary_file_link) {
              window.open(currentSalary.salary_file_link, "_blank");
            }
          }}>
          <Download size={14} />
        </button>
      };
    });

    const firstDateEmployees = _.filter(calculatedEmployees, (employee) => employee.userTerms?.salary_date === SalaryDate.first)
    const ninthDateEmployees = _.filter(calculatedEmployees, (employee) => employee.userTerms?.salary_date === SalaryDate.ninth)

    setGroupedEmployees({
      firstDateSalaryEmployees: _.sortBy(firstDateEmployees, "agentTotalIncomes").reverse(),
      ninthDateSalaryEmployees: _.sortBy(ninthDateEmployees, "agentTotalIncomes").reverse(),
    });
    // eslint-disable-next-line
  }, [employees, currentMonth]);


  useEffect(() => {
    if (!filterValue) {
      setFilteredEmployees({ ...groupedEmployees })
    } else {
      setFilteredEmployees({
        firstDateSalaryEmployees: filterEmployee(groupedEmployees.firstDateSalaryEmployees, filterValue),
        ninthDateSalaryEmployees: filterEmployee(groupedEmployees.ninthDateSalaryEmployees, filterValue),
      });
    }

    setUpdateTable(false);
    setTimeout(() => setUpdateTable(true));

  }, [filterValue, groupedEmployees]);

  const handleSendToMaskoreshet = async (employee, salary) => {
    if (!salary?.id || salary.status !== SalaryStatus.done || salary.is_sent_to_maskoreshet) {
      return;
    }

    await sendSalaryToMaskoreshet(salary.id);
    const salaries = [...employee.salaries];
    const index = _.findIndex(salaries, { id: salary.id });
    salaries.splice(index, 1, { ...salary, is_sent_to_maskoreshet: true });
    refreshEmployee({ ...employee, salaries });
    enqueueSnackbar(t("maskoreshet-sent-successfully"), { variant: 'success' });
  };

  useEffect(() => {
    if (!selectedEmployee)
      return;

    const currentSalary = _.find(selectedEmployee.salaries, (salary) =>
      salary.year === currentMonth.year &&
      salary.month === currentMonth.month);

    if (!currentSalary)
      createEmployeeSalary();

    // eslint-disable-next-line
  }, [selectedEmployee, currentMonth]);

  const createEmployeeSalary = async (employee = selectedEmployee, salaryForCreate = {}) => {
    const salary = {
      ...salaryForCreate,
      user_id: employee.id,
      month: currentMonth.month,
      year: currentMonth.year,
      status: SalaryStatus.open
    }

    const createdSalary = await addSalary(salary);
    const updatedEmployee = { ...employee, salaries: [...( employee.salaries || [] ), createdSalary] };
    refreshEmployee(updatedEmployee);

    if (selectedEmployee?.id === updatedEmployee.id)
      setSelectedEmployee(updatedEmployee);
  }

  const updateEmployeeSalary = (employee, salaryUpdate, invoiceUpdates, expenseUpdates) => {
    const currentSalary = _.find(employee.salaries, (salary) =>
      salary.year === currentMonth.year &&
      salary.month === currentMonth.month);

    if (currentSalary) {
      const update = { salary: { id: currentSalary.id, ...salaryUpdate } };

      if (invoiceUpdates)
        update.invoiceUpdates = invoiceUpdates;

      if (expenseUpdates)
        update.expenseUpdates = expenseUpdates;

      return updateSalary(update)
        .then((updatedSalary) => {
          const salaries = [...employee.salaries]
          const index = _.findIndex(salaries, { id: updatedSalary.id });
          salaries.splice(index, 1, updatedSalary);

          const invoices = _.map(employee.invoices, invoice => {
            const invoiceUpdate = _.find(invoiceUpdates, (update) => update.id === invoice.id && update.invoice_number === invoice.invoice_number) || {};

            return { ...invoice, ...invoiceUpdate };
          });

          const expenses = _.map(employee.expenses, expense => {
            const expenseUpdate = _.find(expenseUpdates, (update) => update.id === expense.id) || {};

            return { ...expense, ...expenseUpdate };
          });

          const updatedEmployee = { ...employee, salaries, invoices, expenses };

          if (selectedEmployee?.id === updatedEmployee.id)
            setSelectedEmployee(updatedEmployee);

          refreshEmployee(updatedEmployee);
        });
    } else {
      return createEmployeeSalary(employee, salaryUpdate);
    }
  }

  const refreshEmployee = (employee) => {
    const updatedEmployees = [...employees];
    const index = _.findIndex(updatedEmployees, { id: employee.id });
    updatedEmployees.splice(index, 1, employee);
    setEmployees(updatedEmployees);
  }

  const exportToCsv = () => {
    const data = _(employees)
      .filter((employee) => ( employee.userTerms?.salary_date === SalaryDate.first && currentTabId === tabIds.first )
        || ( employee.userTerms?.salary_date === SalaryDate.ninth && currentTabId === tabIds.ninth ))
      .map((employee) => {
        const currentSalary = _.find(employee.salaries, (salary) =>
          salary.year === currentMonth.year &&
          salary.month === currentMonth.month);

        if (!currentSalary)
          return;

        return {
          oketz_number: employee.oketz_number,
          // identity_number: employee.identity_number,
          // total_oketz_net: currentSalary.total_oketz_net,
          // total_oketz_net_to_pay: currentSalary.total_oketz_net_to_pay,
          total_oketz_cost: currentSalary.total_oketz_cost,
        }
      })
      .filter(Boolean)
      .value();

    setExportData(data);
    setTimeout(() => csvLink.current.link.click());
  }

  const handleCsvFileUpload = (e) => {
    if (!e.target.files.length) return;
    const fileReader = new FileReader();


    fileReader.onload = function (event) {
      const csvOutput = event.target.result;
      console.log(csvFileToArray(csvOutput));
      setImportData(csvFileToArray(csvOutput));
    };

    fileReader.readAsText(e.target.files[0]);
  }

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");

    return csvRows.map((row) => {
      const values = row.split(",");

      if (_.isNil(+values[0]) || !values[1] || _.isNil(+values[2]) || _.isNil(+values[3]) || _.isNil(+values[4]))
        return;

      return {
        oketz_number: values[0],
        identity_number: +values[1]?.replace("-", ""),
        total_oketz_net_to_pay: +values[2],
        total_oketz_cost: +values[3],
        total_oketz_net: +values[4],
      }
    })
      .filter(Boolean);
  }

  const salaryEmployees = [
    ...groupedEmployees.firstDateSalaryEmployees,
    ...groupedEmployees.ninthDateSalaryEmployees,
  ];
  const salaryTiles = [
    { key: "total", label: t("salary-tile-total"), value: salaryEmployees.length, color: "#1B365D" },
    { key: "first", label: t("salary-tile-first"), value: groupedEmployees.firstDateSalaryEmployees.length, color: "#1B71C4" },
    { key: "ninth", label: t("salary-tile-ninth"), value: groupedEmployees.ninthDateSalaryEmployees.length, color: "#1B6B8A" },
    { key: "monthly-files", label: t("salary-tile-monthly-files"), value: _.filter(salaryEmployees, "monthlyFileDone").length, color: "#4CA83A" },
    { key: "salary-files", label: t("salary-tile-salary-files"), value: _.filter(salaryEmployees, "salaryFileDone").length, color: "#C97A0A" },
  ];
  const countDone = (list) => _.filter(list, (employee) => employee.salaryStatus === SalaryStatus.done).length;
  const firstDoneCount = countDone(groupedEmployees.firstDateSalaryEmployees);
  const ninthDoneCount = countDone(groupedEmployees.ninthDateSalaryEmployees);
  const firstOpenCount = groupedEmployees.firstDateSalaryEmployees.length - firstDoneCount;
  const ninthOpenCount = groupedEmployees.ninthDateSalaryEmployees.length - ninthDoneCount;

  const toggleLanguage = () => {
    const nextLanguage = i18n.language === "heb" ? "en" : "heb";
    i18n.changeLanguage(nextLanguage);
    SessionStorageService.setAppLanguage(nextLanguage);
    dispatch(setLanguage({ language: nextLanguage }));
    document.body.dir = nextLanguage === "heb" ? "rtl" : "ltr";
  };

  const getDateView = (month) => {
    const date = moment();
    date.set('year', month.year);
    date.set('month', month.month - 1);

    return date.format('MM/YYYY');
  }

  if (missingAccessKey) {
    return (
      <div className="salaries-page-wrapper full-screen salary-missing-key">
        {t("salary-missing-key")}
      </div>
    );
  }

  return <div className={"salaries-page-wrapper" + (fullScreen ? " full-screen" : "")}>
    <header className="salaries-header">
      <div className="salaries-header-row">
      {fullScreen && <button
        type="button"
        className="salary-lang-toggle"
        onClick={toggleLanguage}
      >
        <span aria-hidden="true">🌐</span>
        {i18n.language === "heb" ? "EN" : "עב"}
      </button>}
      <div className="salaries-header-title">
        {!selectedEmployee && <div>{t('salaries')}</div>}
        {selectedEmployee && <div className="salaries-header-back" onClick={() => setSelectedEmployee(null)}>
          <ArrowBackIcon/>{`${t('salaries')} : ${selectedEmployee.firstname}`}
          {_.find(selectedEmployee.salaries, (salary) =>
            salary.year === currentMonth.year &&
            salary.month === currentMonth.month)?.status === SalaryStatus.done &&
            <div className="salaries-header-employee-done">{t('done')}</div>}
        </div>}
      </div>
      <div className="salaries-header-dates">
        <DateCarousel onMonthChange={setCurrentMonth}/>
      </div>
      </div>
      {!selectedEmployee && <div className="search-wrapper">
        <Search
          value={filterValue}
          onChange={setFilterValue}
          onClearFilter={() => setFilterValue("")}
          placeholderKey="search-by-name-and-id"
          icon={<SearchIcon size={16} className="salary-search-icon" />}
        />
      </div>}
    </header>
    {showLoader && <Loader/>}
    {!showLoader && !selectedEmployee && <div className="salaries-page-content-wrapper">
      <CSVLink
        data={exportData}
        headers={csvHeaders}
        filename={`עלות.csv`}
        className="btn btn-primary"
        target="_blank"
        style={{ display: "none" }}
        ref={csvLink}
      />
      <div className="salary-sheet">
      <div className="salary-tiles">
        {salaryTiles.map((tile) => (
          <div className="salary-tile" key={tile.key} style={{ borderTopColor: tile.color }}>
            <div className="salary-tile-label">{tile.label}</div>
            <div className="salary-tile-value" style={{ color: tile.color }}>{tile.value}</div>
          </div>
        ))}
      </div>
      <div className="salary-accordion-wrapper">
        <Accordion
          className="salaries-accordion"
          expanded={currentTabId === tabIds.first}
          TransitionProps={{ unmountOnExit: true }}
          onChange={(_, isExpanded) => {
            if (isExpanded) {
              setCurrentTabId(tabIds.first);
              setFilterValue("");
              return;
            }

            if (currentTabId === tabIds.first) {
              setCurrentTabId(null);
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="salaries-accordion-header">
              <div className="salaries-accordion-heading">
                <div className="salaries-accordion-title">{t("1st")}</div>
                <div className="salaries-accordion-count">{groupedEmployees.firstDateSalaryEmployees.length}</div>
              </div>
              <div className="salaries-accordion-stats">
                <span className="is-done">{firstDoneCount} {t("done")}</span>
                <span className="is-open">{firstOpenCount} {t("open")}</span>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className="salaries-accordion-details">
            {currentTabId === tabIds.first && updateTable && <div className="tab-content-wrapper">
              <YeulsTable
                data={filteredEmployees.firstDateSalaryEmployees}
                headers={tableHeaders}
                columns={tableColumns}
                totalCount={filteredEmployees.firstDateSalaryEmployees?.length}
                pagination={true}
                perPageItemCount={12}
                partialPageCount={3}
                nextPageText=">"
                prePageText="<"/>
            </div>}
          </AccordionDetails>
        </Accordion>

        <Accordion
          className="salaries-accordion"
          expanded={currentTabId === tabIds.ninth}
          TransitionProps={{ unmountOnExit: true }}
          onChange={(_, isExpanded) => {
            if (isExpanded) {
              setCurrentTabId(tabIds.ninth);
              setFilterValue("");
              return;
            }

            if (currentTabId === tabIds.ninth) {
              setCurrentTabId(null);
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="salaries-accordion-header">
              <div className="salaries-accordion-heading">
                <div className="salaries-accordion-title">{t("9st")}</div>
                <div className="salaries-accordion-count">{groupedEmployees.ninthDateSalaryEmployees.length}</div>
              </div>
              <div className="salaries-accordion-stats">
                <span className="is-done">{ninthDoneCount} {t("done")}</span>
                <span className="is-open">{ninthOpenCount} {t("open")}</span>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails className="salaries-accordion-details">
            {currentTabId === tabIds.ninth && updateTable && <div className="tab-content-wrapper">
              <YeulsTable
                data={filteredEmployees.ninthDateSalaryEmployees}
                headers={tableHeaders}
                columns={tableColumns}
                totalCount={filteredEmployees.ninthDateSalaryEmployees?.length}
                pagination={true}
                perPageItemCount={12}
                partialPageCount={3}
                nextPageText=">"
                prePageText="<"/>
            </div>}
          </AccordionDetails>
        </Accordion>
      </div>
      </div>
    </div>}

    {!showLoader && selectedEmployee && <EmployeeSalary
      currentMonth={currentMonth}
      employee={selectedEmployee}
      updateEmployeeSalary={updateEmployeeSalary}
      clients={clients}
      supplieers={suppliers}
    />}
    <ConfirmDialog
      open={!!importData}
      onClose={() => setImportData(null)}
      title={`${t('import-salaries')} ${getDateView(importMonth)}`}
      onSubmit={() => {
        setShowLoader(true)
        importSalary({ salaries: importData, month: importMonth.month, year: importMonth.year })
          .then(() => {
            enqueueSnackbar(t("import-finished"), { variant: 'success' });
            setImportData(null);
            return refreshEmployees();
          })
          .catch(() => {
            enqueueSnackbar(t("something-went-wrong"), { variant: 'error' });
          })
          .finally(() => {
            setShowLoader(false)
          })
      }}>
      <div
        className="dialog-content">
        <div className="import-message">
          {t('select-import-month')}
        </div>
        <DateCarousel onMonthChange={setImportMonth}/>
        {/*<div className="import-message">*/}
        {/*  {t('sure-import').replace('{0}', getDateView(importMonth))}*/}
        {/*</div>*/}
      </div>
    </ConfirmDialog>
  </div>
}

const filterEmployee = (employees, filterValue) => {
  const filterValueToLowerCase = filterValue.toLowerCase();

  return _.filter(employees, (employee) =>
    ( employee.firstname?.toLowerCase() || "" ).indexOf(filterValueToLowerCase) !== -1 ||
    ( employee.santec_account_id?.toString() || "" ).indexOf(filterValueToLowerCase) !== -1)
}

export default Salaries;